// @flow
import React, {Component} from 'react'
import Grid from "@material-ui/core/Grid/Grid";
import AppBar from "@material-ui/core/AppBar/AppBar";
import withStyles from "@material-ui/core/es/styles/withStyles";
import Dashboard from "./components/dashboard/dashboard";
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import Alert from "@material-ui/lab/Alert";
import Websocket from 'react-websocket';
import {Mutex} from 'async-mutex';
import Button from "@material-ui/core/Button";

import {ExitToApp as SignInIcon} from '@material-ui/icons';
import Link from "@material-ui/core/Link";
import TextField from "@material-ui/core/TextField";
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Cookies from 'js-cookie';
import Loading from 'react-fullscreen-loading';

const mutex = new Mutex();

export interface WsRes {
  obj_type: string;
}

export interface ContainerStateWaiting {
  reason: string;
  message: string;
}

export interface ContainerStateRunning {
  started_at: string;
}

export interface ContainerStateTerminated {
  exit_code: number;
  signal: number;
  reason: string;
  message: string;
  started_at: string;
  finished_at: string;
}

export interface ContainerState {
  waiting: ContainerStateWaiting;
  running: ContainerStateRunning;
  terminated: ContainerStateTerminated;
}

export interface Container {
  version: string;
  debug: boolean;
  state: ContainerState;
}

export interface Pod {
  event_type: string;
  source: string;
  deployment: string;
  name: string;
  phase: string;
  type: string;
  container: Container;
}

export interface Build {
  source: string;
  pipeline: string;
  status: string;
  result: string;
  url: string;
}

export interface Release {
  source: string;
  pipeline: string;
  version: string;
  url: string;
}

export interface Record {
}

export interface Deployment {
  event_type: string;
  source: string;
  name: string;
  replicas: number;
  version: string;
  pods: Record<string, Pod>;
  build: Build;
  release: Release;
  lowerDeployment: Record<string, Deployment>
}

export interface Source {
  name: string;
  wsEndpoint: string;
  wsAPIKey: string;
  wsAPIKeyReady: boolean;
  failedConnection: boolean;
  deployments: Record<string, Deployment>;
  upperSourceName: string;
  lowerSourceName: string;
}

const styles = theme => ({
  root: {
    paddingTop: "140px",
    width: "calc(100% + 20px)",
  },
  appBar: {
    backgroundColor: "#daf4eb",
    verticalAlign: "middle",
    height: "120px",
    zIndex: 1200,
  },
  dashboard: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    color: 'inherit',
  },
  buttonGroup: {
    margin: "10px",
  },
  textField: {
    margin: "5px 10px 0 10px",
  },
  localToggle: {
    margin: "10px",
    height: "50px",
  },
  countDown: {
    display: "inline-block",
    verticalAlign: "middle",
    margin: "10px",
  },
  warning: {
    display: "inline-block",
    verticalAlign: "middle",
    margin: "10px",
    color: "#cf000f",
  },
  alertLink: {
    color: "#533f03",
    fontWeight: "700",
  }
});

let sources: Record<string, Source> = {
  // "LOCAL": {
  //   name: "LOCAL",
  //   wsEndpoint: "ws://localhost:8080/connect",
  //   deployments: {},
  // },
  "DEV-MAIN-ENG": {
    name: "DEV-MAIN-ENG",
    wsEndpoint: "wss://monitoring-api-dev.eng.mspenv.io/connect",
    deployments: {},
    upperSourceName: "QA-MAIN-ENG",
  },
  "QA-MAIN-ENG": {
    name: "QA-MAIN-ENG",
    wsEndpoint: "wss://monitoring-api-qa.eng.mspenv.io/connect",
    deployments: {},
    upperSourceName: "SB-MAIN-WBC",
    lowerSourceName: "DEV-MAIN-ENG",
  },
  "DEV-NONPROD-INTEGRATION": {
    name: "DEV-NONPROD-INTEGRATION",
    wsEndpoint: "wss://monitoring-api-dev.integration-nonprod.mspenv.io/connect",
    deployments: {},
    upperSourceName: "QA-NONPROD-INTEGRATION",
  },
  "QA-NONPROD-INTEGRATION": {
    name: "QA-NONPROD-INTEGRATION",
    wsEndpoint: "wss://monitoring-api-qa.integration-nonprod.mspenv.io/connect",
    deployments: {},
    lowerSourceName: "DEV-NONPROD-INTEGRATION",
  },
  "SB-MAIN-GKO": {
    name: "SB-MAIN-GKO",
    wsEndpoint: "wss://monitoring-api-sb.gko.mspenv.io/connect",
    deployments: {},
    lowerSourceName: "QA-MAIN-ENG",
    upperSourceName: "LIVE-MAIN-GKO",
  },
  "LIVE-MAIN-GKO": {
    name: "LIVE-MAIN-GKO",
    wsEndpoint: "wss://monitoring-api.gko.mspenv.io/connect",
    deployments: {},
    lowerSourceName: "SB-MAIN-GKO",
  },
  "SB-MAIN-WBC": {
    name: "SB-MAIN-WBC",
    wsEndpoint: "wss://monitoring-api-sb.wbc.mspenv.io/connect",
    deployments: {},
    lowerSourceName: "QA-MAIN-ENG",
    upperSourceName: "LIVE-MAIN-WBC",
  },
  "LIVE-MAIN-WBC": {
    name: "LIVE-MAIN-WBC",
    wsEndpoint: "wss://monitoring-api.wbc.mspenv.io/connect",
    deployments: {},
    lowerSourceName: "SB-MAIN-WBC",
  },
  "SB-MAIN-TILL": {
    name: "SB-MAIN-TILL",
    wsEndpoint: "wss://monitoring-api-sb.till.mspenv.io/connect",
    deployments: {},
    lowerSourceName: "QA-MAIN-ENG",
  },
  "SB-MAIN-CBA": {
    name: "SB-MAIN-CBA",
    wsEndpoint: "wss://monitoring-api-sb.cba.mspenv.io/connect",
    deployments: {},
    lowerSourceName: "QA-MAIN-ENG",
  },
  "SB-MAIN-NEXT": {
    name: "SB-MAIN-NEXT",
    wsEndpoint: "wss://monitoring-api-sb.next.mspenv.io/connect",
    deployments: {},
    lowerSourceName: "QA-MAIN-ENG",
  },
  "SB-MAIN-FISVAU": {
    name: "SB-MAIN-FISVAU",
    wsEndpoint: "wss://monitoring-api-sb.fisvau.mspenv.io/connect",
    deployments: {},
    lowerSourceName: "QA-MAIN-ENG",
  },
  "SB-MAIN-POSPAY": {
    name: "SB-MAIN-POSPAY",
    wsEndpoint: "wss://monitoring-api-sb.pospay.mspenv.io/connect",
    deployments: {},
    lowerSourceName: "QA-MAIN-ENG",
  },
  "LIVE-MAIN-CBA": {
    name: "LIVE-MAIN-CBA",
    wsEndpoint: "wss://monitoring-api.cba.mspenv.io/connect",
    deployments: {},
    lowerSourceName: "SB-MAIN-CBA",
  },
  "LIVE-MAIN-TILL": {
    name: "LIVE-MAIN-TILL",
    wsEndpoint: "wss://monitoring-api.till.mspenv.io/connect",
    deployments: {},
    lowerSourceName: "SB-MAIN-TILL",
  },
  "LIVE-MAIN-NEXT": {
    name: "LIVE-MAIN-NEXT",
    wsEndpoint: "wss://monitoring-api.next.mspenv.io/connect",
    deployments: {},
    lowerSourceName: "SB-MAIN-NEXT",
  },
  "LIVE-MAIN-FISVAU": {
    name: "LIVE-MAIN-FISVAU",
    wsEndpoint: "wss://monitoring-api.fisvau.mspenv.io/connect",
    deployments: {},
    lowerSourceName: "SB-MAIN-FISVAU",
  },
  "LIVE-MAIN-POSPAY": {
    name: "LIVE-MAIN-POSPAY",
    wsEndpoint: "wss://monitoring-api.pospay.mspenv.io/connect",
    deployments: {},
    lowerSourceName: "SB-MAIN-POSPAY",
  },
  "LIVE-PROD-INTEGRATION": {
    name: "LIVE-PROD-INTEGRATION",
    wsEndpoint: "wss://monitoring-api.integration.mspenv.io/connect",
    deployments: {},
    lowerSourceName: "QA-NONPROD-INTEGRATION",
  },
}

const tenants = {
  // Disabling local
  // "LOCAL": Object.keys(sources).filter(k => k.includes("LOCAL")),
  "ENG": Object.keys(sources).filter(k => k.includes("-ENG")),
  "GKO": Object.keys(sources).filter(k => k.includes("-GKO")),
  "WBC": Object.keys(sources).filter(k => k.includes("-WBC")),
  "TILL": Object.keys(sources).filter(k => k.includes("-TILL")),
  "CBA": Object.keys(sources).filter(k => k.includes("-CBA")),
  "NEXT": Object.keys(sources).filter(k => k.includes("-NEXT")),
  "FISVAU": Object.keys(sources).filter(k => k.includes("-FISVAU")),
  "POSPAY": Object.keys(sources).filter(k => k.includes("-POSPAY")),
  "INTEGRATION": Object.keys(sources).filter(k => k.includes("-INTEGRATION")),
};

const tenantsDefaultEnv = {
  // Disabling local
  // "LOCAL": "LOCAL",
  "ENG": "DEV",
  "GKO": "SB",
  "WBC": "SB",
  "TILL": "SB",
  "CBA": "SB",
  "NEXT": "SB",
  "FISVAU": "SB",
  "POSPAY": "SB",
  "INTEGRATION": "DEV",
};

const shouldShowAccountClass = (tenant, accountClass: string) => (tenants[tenant] || []).filter(cluster => cluster.includes(accountClass)).length > 0;
const shouldShowEnv = (tenant, accountClass, env: string) => {
  if (tenant === "INTEGRATION") {
    if (accountClass === "NONPROD" && (env === "DEV" ||env === "QA" )) {
      return true
    }

    return (accountClass === "PROD" && env === "LIVE")
  }

  return (tenants[tenant] || []).filter(cluster => cluster.includes(env)).length > 0;
}
const tenantDefaultEnv = (tenant: string) => (tenantsDefaultEnv[tenant] ? tenantsDefaultEnv[tenant] : null)

const fromLocalStorageOrDefault = (item, defaultValue) => {
  let blob = localStorage.getItem(item);

  let v;
  try {
    v = JSON.parse(blob);
  } catch (e) {
    console.error("error parsing selected tab json", e)
    v = defaultValue
  }


  return v ? v : defaultValue
}


class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sources: sources,
      selectedClass: "MAIN",
      selectedEnv: "DEV",
      selectedTenant: "ENG",
      local: false,
      filter: "",
      filteredDeployments: [],
      signedIn: false,
      signingIn: false
    };

    this.handleLoad = this.handleLoad.bind(this);
    this.changeClass = this.changeClass.bind(this);
    this.changeEnv = this.changeEnv.bind(this);
    this.handleLocalToggle = this.handleLocalToggle.bind(this);
    this.handleData = this.handleData.bind(this);
    this.handleDeployment = this.handleDeployment.bind(this);
    this.handlePod = this.handlePod.bind(this);
    this.handleBuild = this.handleBuild.bind(this);
    this.handleRelease = this.handleRelease.bind(this);
    this.handleWSOpen = this.handleWSOpen.bind(this);
    this.handleWSClose = this.handleWSClose.bind(this);
    this.sort = this.sort.bind(this);
    this.handleOpenMDSpec = this.handleOpenMDSpec.bind(this);
    this.handleOpenSDSpec = this.handleOpenSDSpec.bind(this);
    this.handleOpenDGWSpec = this.handleOpenDGWSpec.bind(this);
    this.quickSearch = this.quickSearch.bind(this);
    this.filterDeployment = this.filterDeployment.bind(this);
    this.handleChangeTenant = this.handleChangeTenant.bind(this);
    this.handleSignIn = this.handleSignIn.bind(this);
  }

  componentDidMount() {
    window.addEventListener('load', this.handleLoad);
  }

  handleLoad() {
    let _this = this

    let signedIn = !!Cookies.get('authenticated')

    // This forces a reset of local storage
    const appVersion = fromLocalStorageOrDefault("appVersion", "")
    if (appVersion !== "1") {
      localStorage.clear();
      localStorage.setItem("appVersion", JSON.stringify("1"));
    }

    const selectedTenant = fromLocalStorageOrDefault("selectedTenant", "ENG")
    const selectedClass = fromLocalStorageOrDefault("selectedClass", "MAIN")
    const selectedEnv = fromLocalStorageOrDefault("selectedEnv", "DEV")
    const local = fromLocalStorageOrDefault("local", false)

    mutex
      .acquire()
      .then(function (release) {
        const {sources} = _this.state;

        _this.setState({
          sources,
          selectedTenant,
          selectedClass,
          selectedEnv,
          local,
          signedIn
        })

        release()
      });
  }

  handleSignIn = () => {
    this.setState({signingIn: true})
    // We use the dev/main endpoint for SSO auth
    window.location.replace('https://monitoring-api-dev.eng.mspenv.io/auth/sso');
  }

  handleOpenMDSpec = () => {
    window.open("https://monitoring-api-dev.eng.mspenv.io/docs/merchant-dashboard", "_blank")
  }

  handleOpenSDSpec = () => {
    window.open("https://monitoring-api-dev.eng.mspenv.io/docs/support-dashboard", "_blank")
  }

  handleOpenDGWSpec = () => {
    window.open("https://monitoring-api-dev.eng.mspenv.io/docs/device-gateway", "_blank")
  }

  handleChangeTenant(event: any, newTenant: any) {
    if (newTenant !== null) {
      this.setState({selectedTenant: newTenant, local: newTenant === "LOCAL"})
      localStorage.setItem("selectedTenant", JSON.stringify(newTenant));

      if (newTenant === "INTEGRATION") {
        this.setState({selectedClass: "NONPROD"})
        localStorage.setItem("selectedClass", JSON.stringify("NONPROD"));
      } else {
        this.setState({selectedClass: "MAIN"})
        localStorage.setItem("selectedClass", JSON.stringify("MAIN"));
      }

      if (!shouldShowEnv(newTenant, this.state.selectedClass, this.state.selectedEnv)) {
        let newEnv = tenantDefaultEnv(newTenant)
        if (newEnv && newTenant !== "LOCAL") {
          this.setState({selectedEnv: newEnv})
          localStorage.setItem("selectedEnv", JSON.stringify(newEnv));
        }
      }
    }
  }

  changeClass(event: any, newClass: string) {
    if (newClass !== null) {
      this.setState({selectedClass: newClass})
      localStorage.setItem("selectedClass", JSON.stringify(newClass));
    }
  }

  changeEnv(event: any, newEnv: string) {
    if (newEnv !== null) {
      this.setState({selectedEnv: newEnv})

      localStorage.setItem("selectedEnv", JSON.stringify(newEnv));
    }
  }

  handleLocalToggle() {
    let local = !this.state.local
    this.setState({local: local})
    localStorage.setItem("local", JSON.stringify(local));
  }

  handleWSOpen(sourceName: string) {
    let _this = this
    mutex
      .acquire()
      .then(function (release) {
        const {sources} = _this.state;
        sources[sourceName].failedConnection = false
        _this.setState({sources: sources});
        release()
      });
  }

  handleWSClose(sourceName: string) {
    let _this = this
    mutex
      .acquire()
      .then(function (release) {
        const {sources} = _this.state;
        sources[sourceName].failedConnection = true
        sources[sourceName].deployments = {}
        _this.setState({sources: sources, signedIn: false});

        release()
      });
  }

  handleData(data) {
    let _this = this
    mutex
      .acquire()
      .then(function (release) {
        let res: WsRes = JSON.parse(data)
        switch (res.obj_type) {
          case "DEPLOYMENT":
            _this.handleDeployment(res)
            break
          case "POD":
            _this.handlePod(res)
            break
          case "BUILD":
            _this.handleBuild(res)
            break
          case "RELEASE":
            _this.handleRelease(res)
            break
          default:
            console.info("object type not detected: " + res.obj_type)
        }
        release()
      });
  }

  handleDeployment(d: Deployment) {
    const {sources} = this.state;

    const ss = d.source.split('-');
    const updatedSource = ss.join('-');
    // find by name and with valid API key
    const srcs = Object.keys(sources).filter(s => s.includes(updatedSource))
    if (srcs.length === 0) {
      return
    }

    let s = sources[srcs[0]]
    if (!s) {
      return
    }

    if (s.deployments[d.name]) {
      d.pods = s.deployments[d.name].pods
      d.build = s.deployments[d.name].build
      d.release = s.deployments[d.name].release
    }

    s.deployments[d.name] = d

    let upperSource = sources[s.upperSourceName]
    if (upperSource) {
      let upperSourceDeployment = upperSource.deployments[d.name]
      if (upperSourceDeployment) {
        upperSourceDeployment.lowerDeployment = d
      }
    }

    let lowerSource = sources[s.lowerSourceName]
    if (lowerSource) {
      let lowerSourceDeployment = lowerSource.deployments[d.name]
      if (lowerSourceDeployment) {
        s.deployments[d.name].lowerDeployment = lowerSourceDeployment
      }
    }

    s.deployments = this.sort(s.deployments)

    this.setState({sources: sources});
  }

  handlePod(p: Pod) {
    const {sources} = this.state

    let s = sources[p.source]
    if (!s) {
      return
    }

    let d = s.deployments[p.deployment]
    if (!d) {
      d = s.deployments[p.deployment] = {
        source: p.source,
        name: p.deployment,
        build: {},
        release: {},
        pods: {}
      }
    }

    d.pods[p.name] = p

    if (p.event_type === "DELETED") {
      delete d.pods[p.name]
    }

    s.deployments = this.sort(s.deployments)
    d.pods = this.sort(d.pods)

    this.setState({sources: sources})
  }


  handleBuild(b: Build) {
    const {sources} = this.state

    let s = sources[b.source]
    if (!s) {
      return
    }

    let d = s.deployments[b.pipeline]
    if (!d) {
      d = s.deployments[b.pipeline] = {
        source: b.source,
        name: b.pipeline,
        build: {},
        release: {},
        pods: {}
      }
    }

    d.build = b

    s.deployments = this.sort(s.deployments)
    this.setState({sources: sources})
  }


  handleRelease(r: Release) {
    const {sources} = this.state

    let s = sources[r.source]
    if (!s) {
      return
    }

    let d = s.deployments[r.pipeline]
    if (!d) {
      d = s.deployments[r.pipeline] = {
        source: r.source,
        name: r.pipeline,
        build: {},
        release: {},
        pods: {}
      }
    }

    d.release = r

    s.deployments = this.sort(s.deployments)
    this.setState({sources: sources})
  }

  sort(deployments: Record<string, Deployment>) {
    const sorted = {};
    Object.keys(deployments).sort().forEach(function (key: string) {
      sorted[key] = deployments[key];
    });

    return sorted
  }

  quickSearch(e) {
    const {sources} = this.state
    let s = e.target.value
    let filteredDeployments = []

    Object.keys(sources).forEach(function (sKey: string) {
      Object.keys(sources[sKey].deployments).forEach(function (dKey: string) {
        let d = sources[sKey].deployments[dKey]
        if (d.name.includes(s)) {
          filteredDeployments.push(d.name)
        }
      });
    });

    this.setState({filter: s, filteredDeployments: filteredDeployments})
  }

  filterDeployment(d: Deployment) {
    const {filter, filteredDeployments} = this.state
    if (filter === "") {
      return true
    }

    return filteredDeployments.includes(d.name)
  }

  render() {
    const {classes} = this.props;

    return (
      <React.Fragment>
        {this.state.signingIn && <Loading loading background="#daf4eb" loaderColor="#50c496"/>}
        <Grid container spacing={3} className={classes.root}>
          <AppBar className={classes.appBar}>
            <Tabs value={this.state.selectedTenant} onChange={this.handleChangeTenant} textColor="primary">
              {/*DISABLING LOCAL*/}
              {/*<Tab value="LOCAL" label="LOCAL"/>*/}
              <Tab value="ENG" label="ENG"/>
              <Tab value="GKO" label="GKO"/>
              <Tab value="WBC" label="WBC"/>
              <Tab value="TILL" label="TILL"/>
              <Tab value="CBA" label="CBA"/>
              <Tab value="NEXT" label="NEXT"/>
              <Tab value="FISVAU" label="FISVAU"/>
              <Tab value="POSPAY" label="POSPAY"/>
              <Tab value="INTEGRATION" label="INTEGRATION"/>
            </Tabs>
            <div>
              <div style={{float: "left", margin: "7px 7px 0 15px"}}>
                <svg width="100" height="50" viewBox="0 0 900 500"><title>mx51 Logo</title>
                  <g id="_logo-mx">
                    <path fill="#000000"
                          d="M112.117 144.085 C127.258 144.085 141.599 148.134 154.292 156.331 166.984 164.928 175.579 178.023 180.077 195.667 L174.78 199.317 176.828 191.569 C180.476 182.572 186.623 174.375 195.667 167.377 204.262 160.429 214.456 154.731 225.549 150.183 236.593 146.135 247.237 144.085 257.431 144.085 273.821 144.085 287.363 147.734 298.006 154.731 308.6 161.679 316.395 171.076 321.742 182.972 326.639 194.818 329.088 208.364 329.088 223.508 L329.088 342.667 C329.088 344.717 328.288 346.766 327.039 348.365 325.39 350.015 323.341 350.814 320.893 350.814 318.444 350.814 316.395 350.015 315.196 348.365 313.547 346.766 312.698 344.717 312.698 342.667 L312.698 225.157 C312.698 213.261 310.649 202.215 307.001 191.969 302.903 182.122 296.757 174.375 288.562 168.227 279.967 162.479 269.323 159.63 255.831 159.63 243.939 159.63 232.495 162.479 221.452 168.227 210.359 174.375 200.964 182.122 194.018 191.969 186.623 202.215 182.975 213.261 182.975 225.157 L182.975 342.667 C182.975 344.717 182.125 346.766 180.926 348.365 179.277 350.015 177.228 350.814 174.78 350.814 172.331 350.814 170.282 350.015 169.033 348.365 167.384 346.766 166.585 344.717 166.585 342.667 L166.585 223.109 C166.585 211.213 164.936 200.566 161.238 191.169 157.59 181.723 151.444 173.975 143.648 168.227 135.853 162.479 125.209 159.63 112.117 159.63 100.674 159.63 89.63 162.479 78.987 168.227 67.943 173.975 58.899 181.723 51.953 191.169 45.007 200.566 41.309 211.213 41.309 223.109 L41.309 342.667 C41.309 344.717 40.51 346.766 38.861 348.365 37.212 350.015 35.163 350.814 33.114 350.814 30.665 350.814 28.617 350.015 27.417 348.365 25.768 346.766 24.919 344.717 24.919 342.667 L24.919 154.731 C24.919 152.682 25.768 150.633 27.417 148.984 29.016 147.334 31.065 146.535 33.114 146.535 35.562 146.535 37.611 147.334 39.26 148.984 40.51 150.633 41.309 152.682 41.309 154.731 L41.309 199.317 29.016 220.209 C29.016 210.813 31.515 201.365 36.012 192.369 40.51 183.372 46.656 175.174 54.801 167.827 62.197 160.829 71.191 155.131 81.435 150.633 91.279 146.135 101.473 144.085 112.117 144.085 Z"></path>
                    <path fill="#000000"
                          d="M367.561 142.036 C370.46 142.036 372.508 143.235 374.108 145.685 L521.92 339.369 C523.119 340.618 523.519 342.218 523.519 344.266 523.519 346.316 522.719 348.365 521.47 350.015 519.871 351.614 517.822 352.414 515.773 352.414 513.325 352.414 510.826 351.214 508.777 348.815 L360.616 155.531 C359.366 154.282 358.967 152.682 358.967 150.633 358.967 148.134 359.816 146.084 361.865 144.485 363.464 142.835 365.513 142.036 367.561 142.036 Z M367.561 352.414 C365.513 352.414 363.864 352.014 362.265 350.415 360.616 349.215 359.816 347.566 359.816 344.717 359.816 342.667 360.216 341.018 361.415 339.768 L433.072 246.85 442.917 259.546 374.108 349.215 C372.508 351.214 370.46 352.414 367.561 352.414 Z M515.773 142.036 C518.622 142.036 520.67 142.835 521.92 144.085 522.719 145.285 523.519 146.934 523.519 148.984 523.519 149.783 523.519 150.633 523.119 151.433 522.719 152.682 521.92 153.482 521.47 154.282 L449.862 250.099 441.268 235.804 508.777 145.685 C510.826 143.235 513.325 142.036 515.773 142.036 Z"></path>
                  </g>
                  <g id="_logo-51">
                    <path fill="#00b478"
                          d="M627.434 399.803 C616.182 399.803 604.508 398.059 592.833 394.677 580.683 391.19 570.329 386.012 562.089 379.09 559.078 376.448 556.489 373.014 554.746 369.104 553.002 365.193 552.157 361.336 552.157 357.426 552.157 353.516 553.848 349.183 557.757 345.326 561.243 341.416 565.998 339.672 572.495 339.672 577.25 339.672 582.427 341.839 588.501 346.594 594.101 350.504 600.176 353.516 607.096 356.105 613.594 358.747 620.091 360.015 627.011 360.015 640.429 360.015 652.949 357.003 664.201 351.349 675.03 345.749 684.116 337.505 690.613 327.149 697.111 317.162 700.122 305.908 700.122 293.807 700.122 281.232 697.534 270.875 691.934 261.787 686.282 253.121 678.939 246.199 669.853 241.444 660.344 236.636 649.938 234.047 638.263 234.047 628.755 234.047 620.514 235.368 613.171 238.38 605.776 241.444 599.331 244.456 593.678 247.468 587.604 250.532 582.849 252.224 578.095 252.224 570.752 252.224 565.1 250.532 561.243 247.045 557.334 244.034 554.746 239.701 553.848 234.945 552.58 230.189 552.58 225.857 553.002 221.947 L568.163 111.143 C569.009 106.387 571.174 102.055 575.506 98.568 579.415 95.556 584.17 93.812 589.769 93.812 L716.604 93.812 C722.203 93.812 727.38 95.556 731.289 99.465 735.198 103.323 736.942 108.554 736.942 114.155 736.942 119.808 735.198 124.564 731.289 128.422 727.38 132.332 722.203 134.075 716.604 134.075 L600.599 134.075 605.353 130.165 591.512 225.381 585.015 212.436 C587.604 209.371 591.935 206.781 598.433 203.77 604.508 201.181 611.428 199.015 619.669 196.848 627.434 195.104 635.252 194.259 643.44 194.259 662.51 194.259 679.784 198.592 694.945 206.781 710.106 215.448 721.781 227.125 730.444 242.29 739.107 257.454 743.439 274.31 743.439 293.385 743.439 308.497 740.375 322.341 734.3 335.339 728.278 348.338 720.037 359.593 709.208 369.104 698.432 379.09 686.282 386.435 672.441 391.613 658.178 397.214 643.44 399.803 627.434 399.803 Z"></path>
                    <path fill="#00b478"
                          d="M845.955 396.791 C839.458 396.791 833.858 394.677 829.527 390.345 825.195 386.435 823.029 381.257 823.029 374.757 L823.029 142.741 828.681 150.508 787.107 175.184 C783.674 177.351 779.765 178.672 775.856 178.672 769.358 178.672 764.181 176.505 760.272 171.274 755.94 166.519 753.774 161.763 753.774 156.162 753.774 148.342 757.684 142.318 765.026 137.51 L833.013 96.823 C837.345 94.658 842.522 93.389 849.019 93.812 855.042 93.812 860.271 95.979 864.127 99.889 868.036 104.221 869.78 109.4 869.78 115.899 L869.78 374.757 C869.78 381.256 867.614 386.435 863.282 390.344 858.528 394.677 852.875 396.791 845.955 396.791 Z"></path>
                  </g>
                  <g id="_logo-underscore">
                    <path fill="#00b478"
                          d="M566.782 447.045 C562.713 447.045 559.786 445.902 557.43 443.546 555.074 441.189 553.932 438.261 553.932 435.334 553.932 431.264 555.074 428.337 557.43 426.552 559.786 424.838 562.713 423.695 566.782 423.695 L853.326 423.695 C857.466 423.695 860.393 424.838 862.677 426.552 865.033 428.337 866.246 431.264 866.246 435.334 866.246 438.261 865.033 441.189 862.677 443.546 860.393 445.902 857.466 447.045 853.326 447.045 Z"></path>
                  </g>
                </svg>
              </div>
              <ToggleButtonGroup
                exclusive={true}
                value={this.state.local}
                onChange={this.handleLocalToggle}
                className={classes.buttonGroup}
              >
                {this.state.selectedTenant === "LOCAL" && <ToggleButton value={true}>LOCAL</ToggleButton>}
              </ToggleButtonGroup>
              {
                !this.state.local &&
                <React.Fragment>
                  <ToggleButtonGroup
                    exclusive={true}
                    value={this.state.selectedClass}
                    onChange={this.changeClass}
                    className={classes.buttonGroup}
                  >
                    {shouldShowAccountClass(this.state.selectedTenant, "MAIN") &&
                      <ToggleButton value="MAIN">MAIN</ToggleButton>}
                    {shouldShowAccountClass(this.state.selectedTenant, "NONPROD") &&
                      <ToggleButton value="NONPROD">NONPROD</ToggleButton>}
                    {shouldShowAccountClass(this.state.selectedTenant, "PROD") &&
                      <ToggleButton value="PROD">PROD</ToggleButton>}
                  </ToggleButtonGroup>

                  <ToggleButtonGroup
                    exclusive={true}
                    value={this.state.selectedEnv}
                    onChange={this.changeEnv}
                    className={classes.buttonGroup}
                  >
                    {shouldShowEnv(this.state.selectedTenant, this.state.selectedClass, "DEV") && <ToggleButton value="DEV">DEV</ToggleButton>}
                    {shouldShowEnv(this.state.selectedTenant, this.state.selectedClass, "QA") && <ToggleButton value="QA">QA</ToggleButton>}
                    {shouldShowEnv(this.state.selectedTenant, this.state.selectedClass, "SB") && <ToggleButton value="SB">SB</ToggleButton>}
                    {shouldShowEnv(this.state.selectedTenant, this.state.selectedClass, "LIVE") && <ToggleButton value="LIVE">LIVE</ToggleButton>}
                  </ToggleButtonGroup>
                </React.Fragment>
              }
              <TextField label="Quick Search" className={classes.textField} onChange={this.quickSearch}/>
              <Button variant="outlined" onClick={this.handleOpenMDSpec} className={classes.buttonGroup}>
                MD Spec
              </Button>
              <Button variant="outlined" onClick={this.handleOpenSDSpec} className={classes.buttonGroup}>
                SD Spec
              </Button>
              <Button variant="outlined" onClick={this.handleOpenDGWSpec} className={classes.buttonGroup}>
                DGW Spec
              </Button>
              {!this.state.signedIn &&
                <Button variant="outlined" onClick={this.handleSignIn} className={classes.buttonGroup}>
                  Sign-In &nbsp;
                  <SignInIcon/>
                </Button>}
            </div>
          </AppBar>
          {
            Object.keys(this.state.sources).map((sKey: string) => {
              let s: Source = this.state.sources[sKey]
              return (
                <React.Fragment key={sKey}>
                  {
                    s.wsEndpoint && s.wsEndpoint !== "" && this.state.signedIn &&
                    <React.Fragment>
                      <Websocket
                        url={s.wsEndpoint}
                        onMessage={this.handleData}
                        onOpen={() => this.handleWSOpen(s.name)}
                        onClose={() => this.handleWSClose(s.name)}
                        reconnect={true}
                        debug={false}
                      />
                    </React.Fragment>
                  }
                  {
                    ((!this.state.local && [this.state.selectedEnv, this.state.selectedClass, this.state.selectedTenant].join('-') === s.name) || (this.state.local && s.name === "LOCAL"))
                    &&
                    <React.Fragment>
                      {
                        !s.wsEndpoint || s.wsEndpoint === "" || !this.state.signedIn ?
                          (
                            !this.state.signedIn ?
                              <React.Fragment>
                                <Grid item md={12}>
                                  <Alert severity="warning">
                                    You need to <Link
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault()
                                      this.handleSignIn()
                                    }}
                                    className={classes.alertLink}
                                  >
                                    Sign In.
                                  </Link>
                                  </Alert>
                                </Grid>
                              </React.Fragment>
                              :
                              <React.Fragment>
                                <Grid item md={12}>
                                  <Alert severity="info">Not yet implemented</Alert>
                                </Grid>
                              </React.Fragment>
                          )
                          :
                          s.failedConnection ?
                            <Grid item md={12}>
                              <Alert severity="error">Failed to connect to websocket</Alert>
                            </Grid>
                            :
                            Object.keys(s.deployments).map((dKey: string) => {
                              let deployment: Deployment = s.deployments[dKey]
                              if (this.state.filter !== "" && !this.filterDeployment(deployment)) {
                                return ""
                              }

                              return (
                                deployment.event_type !== "DELETED" &&
                                <Grid item md={2} key={dKey} className={classes.dashboard}>
                                  <Dashboard
                                    deployment={deployment}
                                  />
                                </Grid>
                              );
                            })
                      }
                    </React.Fragment>
                  }
                </React.Fragment>
              )
            })
          }
        </Grid>
      </React.Fragment>
    )
  }
}

export default withStyles(styles)(App)
